import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit
} from '@angular/core';
import {
  ActivatedRoute,
  ParamMap,
  RouteReuseStrategy,
  Router
} from '@angular/router';
import { Company } from 'src/app/classes/models';
import { ReloadRouteReuseStrategy } from 'src/app/classes/routing/reload-reuse-strategy';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.less'],
  providers: [
    { provide: RouteReuseStrategy, useClass: ReloadRouteReuseStrategy }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientsComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private changeDetection: ChangeDetectorRef,
    private router: Router,
    private ToastService: ToastService
  ) {}

  title: string = '';
  Filters: Map<string, any> = new Map();
  initialized: boolean = false;

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  actionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: Company;
  }) {
    const { id } = rowData;
    if (!id) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }

    // if (action === 'edit') {
    //   this.SharedDataService.sendEvent('editCompany', new Company(rowData));
    //   this.router.navigate([ 'admin', 'clients', 'edit', id ]);
    // }

    if (action === 'view') {
      this.router.navigate(['admin', 'client', id, 'clientInfo']);
    }
  }

  addClient() {
    this.router.navigate(['add'], { relativeTo: this.route });
  }

  // This method can be used to re-initialize this component when the route parameter is changed.
  // This way, the grid state is reset to a base state.
  reinitialize() {
    this.initialized = false;
    this.changeDetection.detectChanges();
    this.initialized = true;
  }

  ngOnInit(): void {
    this.initialized = true;
  }
}
